<div id="background-overlay" class="background-image-overlay" [class.fade-out]="fadeOut">
</div>
<div class="background-image">
</div>
